import React from "react";
import MainLayout from "../../layouts/MainLayout/MainLayout";
import styles from "./RiskAnalysis.module.scss";
import { useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import GraphAccordion from "../../components/GraphAccordion/GraphAccordion";
import useFetchOrganizationData from "../../actions/useFetchOrganizationData";

const RiskAnalysis = () => {
  const { orgId } = useParams();
  const location = useLocation();

  // Fetch organization data when navigating through URL
  useFetchOrganizationData();

  const modules = useSelector((state) => state.user.modules);
  const { findingsData, improvementsData, auditsTasksData } = useSelector(
    (state) => state.organization,
  );
  const meModeActive = useSelector((state) => state.filters.meModeActive);
  const currentUser = useSelector((state) => state.user.email);

  // Extracting path from URL
  const lastIndex = location.pathname.lastIndexOf("/");
  const modifiedPath = location.pathname.substring(lastIndex);

  // Find the module object corresponding to the current path
  const currentModule = modules[orgId]?.find(
    (mod) => mod.path === modifiedPath,
  );

  return (
    <MainLayout floatingBarCollapsedByDefault={true}>
      <div className={styles.column}>
        <Breadcrumbs data={currentModule} />
        <div className={styles.graphsWrapper}>
          <span className={styles.title}>RISK ANALYSIS</span>
          <GraphAccordion
            auditsTasksData={auditsTasksData}
            findingsData={findingsData}
            improvementsData={improvementsData}
            meModeActive={meModeActive}
            currentUser={currentUser}
          />
        </div>
      </div>
    </MainLayout>
  );
};

export default RiskAnalysis;
